
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'
import { useSearchParams } from "react-router-dom"

export const PipelineMasterExportData = (props) => {
    const { ExcelData, name, searchName, RoleID } = props

    const [searchParams] = useSearchParams()
    let DashProjectTypeId = searchParams.get('DashProjectTypeId')

    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '48%' }}>

                <h5><span>&emsp;</span></h5>

                <tr>
                    <th colSpan={4} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Navi Mumbai Municipal Corporation</th>
                </tr>
                <tr>
                    <th colSpan={4} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>WATER SUPPLY DEPARTMENT</th>
                </tr>
                {
                    (DashProjectTypeId == '6' && RoleID != '16') ?
                        <tr>
                            <th colSpan={4} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Project Name: - Distribution Line - Morbe Dam to Digha</th>
                        </tr>
                        :
                        <tr>
                            <th colSpan={4} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Project Name: - Main Feeder - Morbe Dam to Digha</th>
                        </tr>
                }
                <tr>
                    <th colSpan={4} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Report Name: {name}</th>
                </tr>
                {/* <tr>
                    <th colSpan={4} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>From Date:- {FromDate ? FromDate : '-'} -- To Date:- {ToDate ? ToDate : '-'} </th>
                </tr> */}

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                        <th className="sr_no_col" style={{ borderLeft: "1px solid black" }}>Sr No.</th>
                        <th>Ward Name</th>
                        {
                            (DashProjectTypeId == '6' && RoleID != '16') ?
                                <th>Location Name</th>
                                :
                                <th>Junction Name</th>
                        }
                        <th style={{ borderRight: "1px solid black" }}>Pipeline Details</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item) => {
                            return (
                                <tr style={{ width: "100%", border: "1px solid black" }}>
                                    <td style={{ textAlign: "left" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                    <td>{item.wardName ? item.wardName : '0'}</td>
                                    {
                                        (DashProjectTypeId == '6' && RoleID != '16') ?
                                            <td>{item.locationDetails ? item.locationDetails : '-'}</td>
                                            :
                                            <td>{item.junctionDetails ? item.junctionDetails : '-'}</td>
                                    }
                                    <td style={{ textAlign: "left" }}>{item.pipelineDetails ? item.pipelineDetails : '-'}</td>
                                </tr>
                            )
                        })
                            :
                            <td colSpan={15}>No data found</td>
                    }
                </tbody>

            </table>
        </div>
    )
}